import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Убери, если не используешь react-router
import { verification } from "../../../redux/requests/IdentificationRequests";
import { useAppDispatch } from "../../../hooks/ReduxHooks";

const ForbiddenPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      dispatch(verification(jwt)).then((data) => {
        if (data.isPass)
          if (data.data.is_admin) navigate("/admin-panel");
          else navigate("/inn-check");
        else navigate("/");
      });
    }
  }, []);
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4">
      <h1 className="text-6xl font-extrabold text-red-600 mb-4">401</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">
        Доступ запрещён
      </h2>
      <p className="text-gray-600 mb-6 text-center max-w-md">
        У вас нет прав для доступа к этой странице. Если вы считаете, что это
        ошибка — обратитесь к администратору.
      </p>
    </div>
  );
};

export default ForbiddenPage;
